namespace $ {

	$mol_test_mocks.push( $ => {
		$.$mol_after_tick = $mol_after_mock_commmon as any as typeof $mol_after_tick
	})

}
